import React, { Component } from 'react';
import { Big3Common, bootstrap } from '../../../js/IncludeManager'
/* 개발담당:양유빈
 * 화면기능:도매공지사항 리스트
 * 세부설명:
*/

export class WhNoticeList extends Component {
    static displayName = WhNoticeList.name;

    constructor(props) {
        super(props);
        this.state = {
            //TotalCount: 0,
            //currentPage:1,
            //StartPage: 1,
            //EndPage: 10,
            NoticeList: []
        };
        this.Wuid = "";
        this.ListCount = 10;  //한페이지당 리스트 개수
        this.PageSize = 10;   //페이징 개수(최대 10개 까지)

        this.TotalCount = 0;  //총 레코드 갯수
        this.currentPage = 1; //현재 페이지 번호
        this.PageNumer = [];  //페이징 리스트 배열
        this.PageNumerCount = 1; 
       
        this.handelPaging_Click = this.handelPaging_Click.bind(this);
    }
    //초기화
    componentDidMount() {
        this.Wuid = this.props.Wuid;
        this.CallWhNoticeData(1, this.ListCount);
    }
    CallWhNoticeData = async (StartPage, EndPage) => {
        try {

            Big3Common.Util.LoadingOn();
            let Paging = { startpage: StartPage, endpage: EndPage, wuid: this.Wuid }
            let Data = await Big3Common.Post('api/MyPage/Notice/GetWHNoticeMgtList', Paging);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                let CallList = JSON.parse(Data.multiDataTable);
                this.TotalCount = CallList.TotalCount;
                this.PageNumerCount = Math.ceil(CallList.TotalCount / this.PageSize);
                this.PageNumer = Array.from({ length: this.PageNumerCount }, (_, index) => ({ number: index + 1 }));
                this.setState({ NoticeList: CallList.DataList });
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("CallWhNoticeData: ", e)
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
        return false;
    } 
    handelPaging_Click = (e, currentPage) => {
        this.currentPage = currentPage;
        const EndPage = (this.ListCount * this.currentPage);
        const StartPage = (EndPage - this.ListCount)+1;
        this.CallWhNoticeData(StartPage, EndPage);
    }
    Pagingrender = () => {

        const PageNumer = this.PageNumer;
        const prevPage = this.currentPage - 1 > 0 ? this.currentPage - 1 : null;
        const nextPage = this.currentPage + 1 <= this.PageNumerCount ? this.currentPage + 1 : null;
       /* console.log("prevPage", prevPage, "currentPage", this.currentPage, "nextPage", nextPage);*/
        return (
            <div aria-label="Page navigation">
                <ul className="pagination">
                    {prevPage !== null ?
                        <li className="page-item pointer" onClick={(e) => { this.handelPaging_Click(e, prevPage) }}>
                            <div className="page-link" aria-label="Previous">
                                <span aria-hidden="true">&laquo;</span>
                            </div>
                            
                        </li>
                    : ""}
                    {PageNumer.map(list =>

                        this.currentPage === list.number ? <li className="page-item pointer" key={list.number}><div className="page-link">{list.number}</div></li>
                            : <li className="page-item pointer" key={list.number} onClick={(e) => { this.handelPaging_Click(e, list.number) }} ><div className="page-link">{list.number}</div></li>
                    )}
                    {nextPage !== null ? 
                        <li className="page-item pointer" onClick={(e) => { this.handelPaging_Click(e, nextPage) }} >
                            <div className="page-link" aria-label="Next">
                                <span aria-hidden="true">&raquo;</span>
                            </div>
                        </li>
                    : ""}
                </ul>
            </div>
        )
    }
    render() {
        const Pagingrender = this.Pagingrender();
        const NoticeList = this.state.NoticeList;       

        //공지사항 상세 클릭
        this.SelectToggle = (event, tagId) => {
            const element = event.target.classList;
            if (element.length === 2) {
                element.remove('collapsed');
            }
            else {
                element.add('collapsed');
            }
            new bootstrap.Collapse('#' + tagId, {
                toggle: true
            });
        }
        return (
            <div  className="modal fade" tabIndex="-1" style={{ zIndex: this.props.zIndex === undefined ? 2000 : this.props.zIndex }} id={this.props.id} data-bs-keyboard="false" data-bs-backdrop="static">
                    <div className="modal-dialog modal-dialog-centered ">
                        <div className="modal-content notice_modal">
                            <div className="notice_modal_head">
                                <div className="modal-title">공지사항 리스트</div>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                        <div className="shop_notice_box">
                            {NoticeList.map(list =>
                                <div key={list.notino}>
                                    <div className="shop_notice_title_box">
                                        <div className="notice_number">{this.TotalCount-(list.rownum-1)}</div>
                                        <div className="shop_notice_title collapsed"
                                            onClick={(e) => { this.SelectToggle(e,`flush-collapse${list.notino}`)}}
                                        >
                                            {list.noti_title}
                                        </div>
                                        <div className="shop_notice_date">{list.reg_dt }</div>
                                    </div>
                                    <div className="shop_notice_cont_box accordion-collapse collapse" id={`flush-collapse${list.notino}`}>
                                        {list.noti_contt }
                                    </div>
                                </div>
                            )}    
                            {Pagingrender }
                        </div>
                        <div className="modal-footer notice_modal_footer2">
                            <button type="button" className="sn_btn" data-bs-dismiss="modal">확인</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
